import React, { Component } from 'react';
import { connect } from 'react-redux';
import DynamicFormList from '../../common/DynamicFormList';
import Input from '../../common/Input';
import CheckBox from '../../common/CheckBox';
import ShowArrow from '../../common/ShowArrow';
import Select from '../../common/Select';
import Toggle from '../../common/Toggle';
import { push } from 'react-router-redux';
import './index.css';

import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import {
  path,
  mergeDeepLeft,
  clone,
} from 'ramda';
import {
  basic as fields,
  newCustomFields,
  allFields,
  options,
} from './fields';
import { validateFields } from '../../utils/validate';
import { linkDataToFields } from '../../utils/fields';
import { getAllFields, updateOrder, setJobCardsTemplate, removeItemById } from '../../api/jobCardsTemplate';
import '../../css/forms/default-forms.css';
import Preloader from "../../common/Preloader";
import hasAccess from "../../helpers/permissionChecker";

// using some little inline style helpers to make the app look okay
const grid = 8;
const style = {
  box: {
    border: '1px solid rgba(0, 0, 0, 0.125)',
    marginBottom: '10px',
    marginTop: '10px',
    borderRadius: '4px',
    boxShadow: '0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12)',
  }
};

const getItemStyle = (draggableStyle, isDragging) => ({
  // some basic styles to make the items look a bit nicer
  padding: grid * 2,
  paddingBottom: 0,
  margin: `0 0 ${grid}px 0`,
  userSelect: 'none',
  cursor: isDragging ? '-webkit-grabbing' : '-webkit-grab',
  // change background colour if dragging
  background: isDragging ? 'lightgreen' : '',
  // cursor: isDragging ? '-webkit-grab' : '-webkit-grabbing',
  // styles we need to apply on draggables
  ...draggableStyle,
  ...style.box,
});

const getListStyle = isDraggingOver => ({
  overflowY: 'scroll',
  height: 500,
  // background: isDraggingOver ? 'lightblue' : 'lightgrey',
  userSelect: 'none',
  cursor: isDraggingOver ? '-webkit-grab' : '-webkit-grabbing',
  padding: grid,
});

export class JobCardsTemplate extends Component {

  constructor(props) {
    super(props);
    this.state = {
      submit: false,
      errors: [],
      fields: fields,
      allFields: {},
      fieldsSync: false,
    };
    this.submit = this.submit.bind(this);
    this.changeFormValue = this.changeFormValue.bind(this);
    this.cancel = this.cancel.bind(this);
    this.fetchAllFields = this.fetchAllFields.bind(this);
    this.onDragEnd = this.onDragEnd.bind(this);
    this.deleteItem = this.deleteItem.bind(this);
  }


  // a little function to help us with reordering the result
  reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    const dataForSend = { "order": [] };
    for (let i = 0; i < result.length; i++) {
      dataForSend.order.push("jobcardlist_" + result[i].name);
    }
    this.props.saveOrder(dataForSend);
    return result;
  };

  onDragEnd(result) {
    // dropped outside the list
    if (!result.destination) {
      return;
    }

    const allAvailableFields = this.reorder(
      this.state.fields.allAvailableFields,
      result.source.index,
      result.destination.index
    );

    this.setState({
      fields: Object.assign(this.state.fields, { allAvailableFields }),
    });
  }

  componentWillMount() {
    this.fetchAllFields();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.fieldsSync === false) {
      const jobCardsTemplateList = path(['jobCardsTemplate', 'list'], this.props);

      if (jobCardsTemplateList) {
        const arrFields = [];
        for (let i = 0; i < jobCardsTemplateList.length; i++) {
          const cloneAllFields = clone(allFields);
          const cloneOptionsFields = clone(options);
          arrFields.push(linkDataToFields(jobCardsTemplateList[i], cloneAllFields, {
            options: function(current, data) {
              return linkDataToFields(data, cloneOptionsFields);
            }.bind(this)
          }));
        }
        const allAvailableFields = this.prepareDataForState(arrFields);
        this.setState({
          fields: Object.assign(this.state.fields, { allAvailableFields }),
          fieldsSync: true,
        });
      }
    }
  }

  prepareDataForState(arrFields) {
    const result = [];
    if (arrFields) {
      for (let i = 0; i < arrFields.length; i++) {
        const currentItem = arrFields[i];
        result.push({
          name: currentItem.id.value,
          value: parseInt(currentItem.value.value),
          label: currentItem.label.value,
          order: currentItem.order.value,
          options: currentItem.options.value,
          show: currentItem.show,
          type: currentItem.type.value,
          showOnDashboard: currentItem.showOnDashboard.value,
        });
      }
    }
    return result;
  }

  getAllChangesInFields(fields) {
    return {
      "fixedfields": this.prepareDataForPost(fields.allAvailableFields),
      "new_customfields": this.prepareDataForPost(fields.newCustomFields, true),
    }
  };

  prepareOptionsForPost(options) {
    const result = {};
    for (const key in options) {
      if (key !== 'id' && options[key] !== null) {
        result[key] = options[key].value;
      }
    }
    return result;
  };

  prepareFieldComponent(options) {
    if (options.hasOwnProperty('type')) {
      switch (options.type.value) {
        case 'Free text field':
          return 'input';
        case 'Number':
          return 'number';
        case 'Dropdown with options':
          return 'dropdown';
        case 'External link':
          return 'link';
        case 'Date picker':
          return 'datepicker';
      }
    }
  }

  prepareDataForPost(fields, isNew) {
    const dataForPost = [];
    for (let i = 0; i < fields.length; i++) {
      const currentItem = fields[i];
      const options = isNew ? currentItem : currentItem.options;
      const tmpFieldObject = {
        id: currentItem.name,
        enabled: currentItem.value,
        label: currentItem.label,
        component: this.prepareFieldComponent(options),
        options: this.prepareOptionsForPost(options),
        showOnDashboard: currentItem.showOnDashboard,
        isRequired: options.isRequired,
      };
      dataForPost.push(tmpFieldObject);
    }
    return dataForPost;
  }

  submit(e) {
    e.preventDefault();
    let result = validateFields(this.state.fields.newCustomFields);
    if (result.check === false) {
      this.setState({
        fields: result.fields,
      });
    } else {
      this.props.saveForm(this.getAllChangesInFields(this.state.fields)).then((json) => {
        let stateClone = clone(this.state);
        stateClone.fields.newCustomFields = [];

        this.setState(mergeDeepLeft(stateClone, this.state));

        this.fetchAllFields().then(() => {
          this.setState({
            fieldsSync: false,
          });
        });
      });
    }
    return false;
  }

  changeFormValue(field, newObject) {
    let stateClone = clone(this.state);
    stateClone.fields[field] = newObject;

    this.setState(mergeDeepLeft(stateClone, this.state));
  }

  renderOptionsOfFields(item, show, type, disableFieldForEdit) {
    return ((!show || show.value) && item) ?
      <div className="col-12">
        {item.label &&
        <Input
          disabled={disableFieldForEdit}
          field={item.label}
          onChange={this.changeFormValue}
        />
        }
        {item.type &&
        <Select
          disabled={disableFieldForEdit}
          field={item.type}
          onChange={this.changeFormValue}
        />
        }
        {(item.type.value === "Dropdown with options" && item.option) &&
        <Input
          disabled={disableFieldForEdit}
          field={item.option}
          onChange={this.changeFormValue}
        />
        }
        {item.width &&
        <Select
          disabled={disableFieldForEdit}
          field={item.width}
          onChange={this.changeFormValue}
        />
        }
        {item.isRequired && type === 'custom_field' &&
        <CheckBox
          disabled={disableFieldForEdit}
          field={item.isRequired}
          onChange={this.changeFormValue}
        />
        }
      </div>
      : ''
  }

  cancel() {
    this.props.goToHome();
  }

  fetchAllFields() {
    return this.props.loadList();
  }

  deleteItem(item) {
    this.props.removeItem(item.name).then(() => {
      this.fetchAllFields().then(() => {
        this.setState({
          fieldsSync: false,
        });
      });
    });
  }

  renderMainPart() {
    const hasAccessForEdit = hasAccess({
      'permAreaKey': 'jobCardTemplateFields',
      'permTypeKey': 'edit',
    });
    const disableFieldForEdit = !hasAccessForEdit;
    return (
      <div className="card-block">
        <div className="col" style={{ paddingBottom: '40px' }}>
          <button className={'btn btn-danger btn-outline pull-right ml-3'} onClick={this.cancel}>
            <i className="fa fa-remove"></i>
            <span className="pl-1">Cancel</span>
          </button>
          {hasAccessForEdit &&
          <button className={'btn btn-success btn-outline pull-right'} onClick={this.submit}>
            <i className="fa fa-check"></i>
            <span className="pl-1">Save</span>
          </button>
          }
        </div>
        {hasAccess({ 'permAreaKey': 'jobCardTemplateFields', 'permTypeKey': 'create' }) &&
        <form onSubmit={this.submit}>
          <div className="col-12" style={{ marginTop: '20px', }}>
            <DynamicFormList
              list={this.state.fields['newCustomFields']}
              onChange={this.changeFormValue}
              fields={newCustomFields}
            />
          </div>
        </form>
        }
        <div style={{ padding: 10 }}>
          <DragDropContext
            onDragEnd={this.onDragEnd}
            style={{
              background: 'white',
            }}
          >
            <Droppable droppableId="droppable" isDropDisabled={!hasAccess({ 'permAreaKey': 'jobCardTemplateFields', 'permTypeKey': 'move' })}>
              {(provided, snapshot) => (
                <div
                  ref={provided.innerRef}
                  style={getListStyle(snapshot.isDraggingOver)}
                >
                  {this.state.fields.allAvailableFields.map(item => (
                    <Draggable
                      key={item.order}
                      draggableId={item.order}
                    >
                      {(provided, snapshot) => (
                        <div>
                          <div
                            ref={provided.innerRef}
                            style={getItemStyle(
                              provided.draggableStyle,
                              snapshot.isDragging,
                            )}
                            {...provided.dragHandleProps}
                            className="row"
                          >
                            <div className="col-6">
                              <CheckBox
                                disabled={disableFieldForEdit}
                                field={item}
                                onChange={this.changeFormValue}
                              />
                            </div>
                            <div className="col-6">
                              {hasAccess({ 'permAreaKey': 'jobCardTemplateFields', 'permTypeKey': 'delete' }) &&
                              <div className="col-1 pull-right">
                                {item.type === 'custom_field' &&
                                <button className="btn" onClick={() => {
                                  this.deleteItem(item);
                                }}>
                                  <i className="fa fa-remove"></i>
                                </button>
                                }
                              </div>
                              }
                              <div className="col-5 pull-right">
                                {item.type !== 'paint_list' && item.type !== 'financial' &&
                                <Toggle className="btn pull-right"
                                        disabled={disableFieldForEdit}
                                        labelPosition="left"
                                        customize={{ 'font-size': '13px' }}
                                        field={{ label: 'Show on a job card', value: item.showOnDashboard }}
                                        onChange={() => {
                                          item.showOnDashboard = !item.showOnDashboard;
                                          this.changeFormValue('showOnDashboard', item)
                                        }}
                                />
                                }
                              </div>
                            </div>
                            {item.options &&
                            <div className="col-12">
                              <ShowArrow
                                field={item.show}
                                onChange={this.changeFormValue}
                              />
                            </div>}
                            {this.renderOptionsOfFields(item.options, item.show, item.type, disableFieldForEdit)}
                          </div>
                          {provided.placeholder}
                        </div>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
        </div>
      </div>
    )
  }

  render() {
    const { fieldsSync } = this.state;
    const mainPart = !fieldsSync ? <Preloader show={true} type='circle'/> : this.renderMainPart();
    return (
      <div className="card">
        <div className="card-header">
          <b>Job Cards Template</b>
        </div>
        {mainPart}
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return state;
};

const mapDispatchToProps = (dispatch) => {
  return {
    goToHome: () => {
      dispatch(push('/'));
    },
    saveOrder: (data) => {
      updateOrder(data)(dispatch);
    },
    loadList: () => {
      return getAllFields()(dispatch);
    },
    saveForm: (data) => {
      return setJobCardsTemplate(data)(dispatch);
    },
    removeItem: (id) => {
      return removeItemById(id)(dispatch);
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(JobCardsTemplate);



// WEBPACK FOOTER //
// ./src/containers/JobCardsTemplate/index.js